import React from 'react';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { getUserAvatarSrc } from '../User/helpers';
import AvatarImage from '../User/AvatarImage';

import s from './GroupCard.scss';

export interface Props {
  group: PapiUser;
  className?: string;
  biData?: BiEvent;
}

const GroupCard: React.FC<Props> = ({ group, className, biData }) => (
  <BiLink
    href={Url.userLink(group.username)}
    className={classnames(s['root'], 'ds-card', className)}
    biData={biData}
  >
    <div className={s['img-wrap']}>
      <AvatarImage
        isGroup={true}
        enableLazyLoad={true}
        src={getUserAvatarSrc(group) ?? undefined}
      />
    </div>
    <div className={s['name']}>{group.username}</div>
  </BiLink>
);
GroupCard.displayName = 'GroupCard';

export default GroupCard;
